import { Heading } from "@chakra-ui/react";
import { ScenarioTable } from "../../components/ScenarioContent/ScenarioTable";

export function ScenarioListPage() {
  return <>
    <Heading as="h1" mb="4">Scenario&apos;s</Heading>
    <ScenarioTable />
  </>
}
